export default __webpack_public_path__ + "static/media/ALUMNI3.201f54ec.jpg";